/**
 * Storlyn 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = 'linear-gradient(90deg, #FF81B0 0%, #EE3BA4 100%)'

export const theme = {
  homeBg: '',
  tagsBg: '',
  tagActiveBg: brandTheme.primaryColor,
  tagActiveText: brandTheme.textInverse,
  tagInactiveBg: '#FCECF3',
  tagInactiveText: '#A66681',
  tabActiveGradient: `linear-gradient(270deg, ${brandTheme.bgGlobal} 0%, ${brandTheme.primaryColor} 95%)`,
  tabActiveColor: brandTheme.textPrimary,
  stickyHeaderBg: brandTheme.bgGlobal,
  primaryGradient,
  tabBorderColor: 'rgba(216, 115, 147, 0.12)',
  tabBackground: 'rgba(243, 166, 192, 0.08)',
  tabTextColor: 'rgba(90, 58, 74, 0.72)',
  tabActiveBorderColor: 'rgba(216, 115, 147, 0.22)',
  tabActiveBackground: 'rgba(243, 166, 192, 0.16)',
  headerIconColor: 'rgba(90, 58, 74, 0.82)',
  isStorlyn: true,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
